import React from "react";
import { useLocation } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";

export default function Route({
  name = "Route name",
  icon,
  onClick = null,
  urlPath = "",
  isCollapsed = false, // 👈 receives from NavBar
}) {
  const location = useLocation();
  const path = location.pathname.split("/")[2];
  const isActive = urlPath === path;

  return (
    <div
      onClick={onClick}
      className={`flex items-center px-4 py-3 cursor-pointer transition-all border-l-4 ${
        isActive
          ? "border-blue-500 bg-[#2a2f45] text-white"
          : "border-transparent text-gray-400 hover:bg-[#2a2f45] hover:text-white"
      } ${isCollapsed ? "justify-center" : "gap-4"}`}
    >
      <div className={`${isCollapsed ? "text-3xl" : "text-xl"}`}>{icon}</div>

      {!isCollapsed && (
        <div className="flex justify-between items-center w-full text-sm font-medium">
          <span>{name}</span>
          <MdOutlineKeyboardArrowRight className="text-base" />
        </div>
      )}
    </div>
  );
}
